export namespace DashboardActions {
  export class GetDashboard {
    static readonly type = '[Dashboard] Get Dashboard';
    constructor(public startDate?: string, public endDate?: string) {}
  }

  export class GetDashboardLine {
    static readonly type = '[Dashboard] Get Dashboard Line';
    constructor(public startDate?: string, public endDate?: string) {}
  }

  export class GetDashboardPie {
    static readonly type = '[Dashboard] Get Dashboard Pie';
    constructor(public startDate?: string, public endDate?: string) {}
  }

  export class LoadingDashboard {
    static readonly type = '[Dashboard] Loading Dashboard';
  }

  export class ErrorDashboard {
    static readonly type = '[Dashboard] Error Dashboard';
    constructor(public error: any) {}
  }
}
